/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

// Material UI
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import ReplayIcon from "@mui/icons-material/Replay";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

// Components
import GraficoTeia from "../components/Resultado/GraficoTeia";
import Criticidade from "../components/Resultado/Criticidade";
import GrauInovacaoGeral from "../components/Resultado/GrauInovacaoGeral";

import { useSelector } from "react-redux";

// Axios
import { postResult } from "../services/resultado";
import { selectToken, selectOrg } from "../storeConfig/reducers/loginReducer";

import {
	calcularGI,
	calcularGrauDeInovacaoGeral,
	classificarOrganizacao,
	grauDeInovaçãoDeCadaDimensão,
} from "../assets/utils/calcularGrauInovação";

import { useQueryClient } from "@tanstack/react-query";

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	padding: theme.spacing(2),
	textAlign: "center",
}));

const Resultado = ({
	EMI,
	GGPI,
	AIO,
	IGC,
	PG,
	calcularNovamente,
	nome_organizacao,
}) => {
	const token = useSelector(selectToken);
	const org = useSelector(selectOrg);
	const queryClient = useQueryClient();

	const [grauGeral, setGrauGeral] = useState("");
	const [grauPorDimensão, setGrauPorDimensão] = useState("");
	const [classificação, setClassificação] = useState("");
	const [data, setData] = useState("");

	const postResultado = () => {
		const data = {
			nome_organizacao: nome_organizacao,
			resultado: {
				EMI: EMI,
				GGPI: GGPI,
				AIO: AIO,
				IGC: IGC,
				PG: PG,
			},
		};

		postResult(token, data).then(() => {
			queryClient.invalidateQueries(["my-results"]);
		});
	};

	const main = (
		resultado,
		callbackGrauDeInovacaoGeral,
		callbackCalcularGI,
		callbackClassificação,
		callbackPorDimensao
	) => {
		const { EMI, GGPI, AIO, IGC, PG } = resultado;

		const emi = callbackCalcularGI(EMI);
		const ggpi = callbackCalcularGI(GGPI);
		const aio = callbackCalcularGI(AIO);
		const igc = callbackCalcularGI(IGC);
		const pg = callbackCalcularGI(PG);

		let grauDeInovaçãoGeral = callbackGrauDeInovacaoGeral(
			EMI,
			GGPI,
			AIO,
			IGC,
			PG
		);
		let classificação = callbackClassificação(grauDeInovaçãoGeral.float);
		let porDimensão = callbackPorDimensao(emi, ggpi, aio, igc, pg);

		setGrauGeral(grauDeInovaçãoGeral.string);
		setClassificação(classificação);
		setGrauPorDimensão(porDimensão);
	};

	const retornarData = () => {
		let today = new Date();
		let dd = String(today.getDate()).padStart(2, "0");
		let mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
		let yyyy = today.getFullYear();

		setData(dd + "/" + mm + "/" + yyyy);
	};

	useEffect(() => {
		postResultado();
		main(
			{ EMI, GGPI, AIO, IGC, PG },
			calcularGrauDeInovacaoGeral,
			calcularGI,
			classificarOrganizacao,
			grauDeInovaçãoDeCadaDimensão
		);
		retornarData();
	}, []);

	return (
		<>
			{grauGeral && grauPorDimensão && classificação && data ? (
				<Container>
					<h1 className="mt-5">{nome_organizacao !== "" ? nome_organizacao : org}</h1>

					<section className="mb-5">
						<GrauInovacaoGeral
							data={data}
							grau={grauGeral}
							classificação={classificação}
						/>
					</section>

					<section className="mb-5">
						<h2>Grau de Inovação por Dimensão</h2>
						<hr />
						<GraficoTeia data={grauPorDimensão} />

						<Box className="mb-5" sx={{ flexGrow: 1 }}>
							<Grid
								container
								rowSpacing={1}
								columnSpacing={{ xs: 1, sm: 2, md: 3 }}
								justifyContent="center"
								alignItems="flex-start"
							>
								<Grid item xs>
									<Item>
										<p>
											Estratégias Metodológicas para
											Inovação
										</p>
										<hr />
										<p>
											{grauPorDimensão[0].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
								<Grid item xs>
									<Item>
										<p>
											Geração e Gestão da Propriedade
											Intelectual
										</p>
										<hr />
										<p>
											{grauPorDimensão[1].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
								<Grid item xs>
									<Item>
										<p>Ações de Inovação Organizacional</p>
										<hr />
										<p>
											{grauPorDimensão[2].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
								<Grid item xs>
									<Item>
										<p>
											Investimento para Geração de
											Conhecimento
										</p>
										<hr />
										<p>
											{grauPorDimensão[3].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
								<Grid item xs>
									<Item>
										<p>
											Perfil do Gestor
											<br />
										</p>
										<hr />
										<p>
											{grauPorDimensão[4].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
							</Grid>
						</Box>
					</section>

					<section className="mb-5">
						<Criticidade
							EMI={EMI}
							GGPI={GGPI}
							AIO={AIO}
							IGC={IGC}
							PG={PG}
						/>
					</section>

					<div className="row d-flex justify-content-around">
						<Button
							className="col-sm-4"
							id="exportar"
							onClick={() => window.print()}
							endIcon={<PictureAsPdfIcon />}
						>
							Exportar como PDF
						</Button>

						<Button
							className="col-sm-4"
							id="calcularNovamente"
							size="large"
							variant="contained"
							endIcon={<ReplayIcon />}
							onClick={calcularNovamente}
						>
							Calcular Novamente
						</Button>
					</div>
				</Container>
			) : (
				<div className="d-flex justify-content-center">
					<CircularProgress />
				</div>
			)}
		</>
	);
};

export default Resultado;
